import React, { FC } from 'react';

import { useParentHierarchySaveBarCopy } from '../hooks/useParentHierarchySaveBarCopy';
import SaveBar, { SAVE_BAR_HEIGHT } from './SaveBar/SaveBar';

type ParentAwareSaveBarProps = Omit<React.ComponentProps<typeof SaveBar>, 'text' | 'detailText'> & {
  /** Display labels for inheritable settings in the pending save (configs/callbacks). */
  inheritableSettingLabels?: string[];
  /** When set, used as the primary save bar line instead of the default. */
  text?: string;
  /** Replaces parent-hierarchy detail copy (e.g. child override messaging). */
  detailTextOverride?: string;
};

/**
 * Save bar that surfaces parent-hierarchy inheritance copy when the merchant has descendants
 * and the pending save includes inheritable settings.
 */
export const ParentAwareSaveBar: FC<ParentAwareSaveBarProps> = ({
  inheritableSettingLabels = [],
  text: textOverride,
  detailTextOverride,
  saveLoading = false,
  ...saveBarProps
}) => {
  const { text: defaultText, detailText } = useParentHierarchySaveBarCopy(
    inheritableSettingLabels,
    saveLoading,
  );
  const resolvedDetailText = detailTextOverride ?? detailText;

  return (
    <SaveBar
      {...saveBarProps}
      saveLoading={saveLoading}
      text={textOverride ?? defaultText}
      detailText={resolvedDetailText}
      emphasizeDetailText={Boolean(resolvedDetailText)}
    />
  );
};

export { SAVE_BAR_HEIGHT };
